import {IRegistration} from "../../store/registrations/interfaces";
import {IProgram} from "../../store/program/interfaces";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

export function useNumPaymentsEnabled() {
    const { payment_configuration } = useSelector(
        (state: RootState) => state.program.data,
    );
    return (payment_configuration.cash.enabled ? 1 : 0) +
        (payment_configuration.transfer.enabled ? 1 : 0) +
        (payment_configuration.debit.enabled ? 1 : 0) +
        (payment_configuration.online.enabled ? 1 : 0) +
        (payment_configuration.custom.enabled ? 1 : 0) +
        (payment_configuration.invoice.enabled ? 1 : 0);
}

export const useCheckPaymentStageSkip = () => {
    const registrations = useSelector(
        (state: RootState) => state.registrations.list,
    );
    const { basic_fee } = useSelector((state: RootState) => state.program.data);
    const totalCost = registrations.reduce((acc, reg) => acc + reg.price, 0);

    // Check if payment configuration is enabled
    const isNoPaymentEnabled = useNumPaymentsEnabled() === 0;

    //Skip Payment stage only when:
    //1. No Payment types are enabled (auto skip because all event prices are set to 0)
    //2. If the total_cost of selected events is 0 and there is no basic_fee
    return isNoPaymentEnabled || (totalCost === 0 && !basic_fee);
};
